import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const PaymentOutgoing = () => {
  return (
    <SettingsMetaData propertyName={"Mode_of_Payment_Outgoing"} viewPropertyName={"Mode of Payment"} />
  );
};
export default PaymentOutgoing;